export const GET_ANNOUNCEMENTS = "GET_ANNOUNCEMENTS";
export const CREATE_NEW_ANNOUNCEMENT = "CREATE_NEW_ANNOUNCEMENT";
export const EDIT_ANNOUNCEMENT = "EDIT_ANNOUNCEMENT";
export const DELETE_ANNOUNCEMENT = "DELETE_ANNOUNCEMENT";
export const SEND_ANNOUNCEMENT_TOGGLE = "SEND_ANNOUNCEMENT_TOGGLE";

export const OPEN_ANNOUNCEMENT_DIALOG = "OPEN_ANNOUNCEMENT_DIALOG";
export const CLOSE_ANNOUNCEMENT_DIALOG = "CLOSE_ANNOUNCEMENT_DIALOG";
